var map = {
	"./behance.svg": 3365,
	"./dribbble.svg": 5070,
	"./github.svg": 3566,
	"./instagram.svg": 8954,
	"./linkedin.svg": 1995,
	"./snapchat.svg": 2524,
	"./spotify.svg": 8947,
	"./twitter.svg": 1411,
	"./whatsapp.svg": 3074,
	"./youtube.svg": 8101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;